import * as types from '../../constants/ActionTypes';


// General type of LoadingState ui hook - loaders that would appear inline should use this
export const apiRequestStart = type => ({
    type: types.REQUEST_PENDING,
    payload: type,
});

export const apiRequestEnd = type => ({
    type: types.REQUEST_COMPLETE,
    payload: type,
});
